import { render, staticRenderFns } from "./ManageOrderBanner.vue?vue&type=template&id=1d90299a&scoped=true&"
import script from "./ManageOrderBanner.vue?vue&type=script&lang=js&"
export * from "./ManageOrderBanner.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrderBanner.vue?vue&type=style&index=0&id=1d90299a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90299a",
  null
  
)

export default component.exports